import { baseFetch } from "./base";
import type { TabbedMessageContent } from "../types";
import { pingSocketAfterSubmit } from "../utils/socket";

export type InteractionType =
  | "fill_in_blank"
  | "ordering"
  | "matching"
  | "ordered_response";

export type InteractionSubmitPayload =
  | { user_answers: Record<string, string> }
  | { user_order: string[] }
  | { user_pairs: Array<{ left_id: string; right_id: string }> };

export interface InteractionSubmitRequest {
  user_id: string;
  message_id: string;
  tab_id: string;
  interaction_type: InteractionType;
  block_index?: number;
  data?: string;
  payload: InteractionSubmitPayload;
}

export interface InteractionSubmitResponse {
  message_id?: string;
  tab_id?: string;
  is_correct?: boolean;
  tab_quiz_status?: "new" | "correct" | "incorrect";
  updated_tab?: TabbedMessageContent;
  updated_block?: unknown;
}

export const postInteractionSubmit = async (
  data: InteractionSubmitRequest,
): Promise<InteractionSubmitResponse> => {
  const response = await baseFetch.post<InteractionSubmitResponse>(
    "/interaction_submit",
    data,
  );
  pingSocketAfterSubmit();
  return response.data;
};
